/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIOrganizationAutocompleteSuggestion } from './APIOrganizationAutocompleteSuggestion';
import {
    APIOrganizationAutocompleteSuggestionFromJSON,
    APIOrganizationAutocompleteSuggestionFromJSONTyped,
    APIOrganizationAutocompleteSuggestionToJSON,
} from './APIOrganizationAutocompleteSuggestion';

/**
 * 
 * @export
 * @interface APIOrganizationAutocompleteResponse
 */
export interface APIOrganizationAutocompleteResponse {
    /**
     * 
     * @type {Array<APIOrganizationAutocompleteSuggestion>}
     * @memberof APIOrganizationAutocompleteResponse
     */
    suggestions: Array<APIOrganizationAutocompleteSuggestion>;
    /**
     * 
     * @type {number}
     * @memberof APIOrganizationAutocompleteResponse
     */
    total: number;
}

/**
 * Check if a given object implements the APIOrganizationAutocompleteResponse interface.
 */
export function instanceOfAPIOrganizationAutocompleteResponse(value: object): value is APIOrganizationAutocompleteResponse {
    if (!('suggestions' in value) || value['suggestions'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    return true;
}

export function APIOrganizationAutocompleteResponseFromJSON(json: any): APIOrganizationAutocompleteResponse {
    return APIOrganizationAutocompleteResponseFromJSONTyped(json, false);
}

export function APIOrganizationAutocompleteResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIOrganizationAutocompleteResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'suggestions': ((json['suggestions'] as Array<any>).map(APIOrganizationAutocompleteSuggestionFromJSON)),
        'total': json['total'],
    };
}

export function APIOrganizationAutocompleteResponseToJSON(value?: APIOrganizationAutocompleteResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'suggestions': ((value['suggestions'] as Array<any>).map(APIOrganizationAutocompleteSuggestionToJSON)),
        'total': value['total'],
    };
}

